import { render, staticRenderFns } from "./BalaList.vue?vue&type=template&id=55899c51&scoped=true"
import script from "./BalaList.vue?vue&type=script&lang=js"
export * from "./BalaList.vue?vue&type=script&lang=js"
import style0 from "./BalaList.vue?vue&type=style&index=0&id=55899c51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55899c51",
  null
  
)

export default component.exports